import React from 'react';
type SectionEyebrowProps = {
  label: string;
  /** 'below' places the short orange rule under the label, 'above' over it. */
  rule?: 'below' | 'above';
  className?: string;
};

/**
 * Small editorial eyebrow label with a short basketball-orange rule.
 * Used to separate major sections without heavy horizontal blocks.
 */
export function SectionEyebrow({
  label,
  rule = 'below',
  className = ''
}: SectionEyebrowProps) {
  const line = <span className="mx-auto block h-[2px] w-8 rounded-full bg-orange" aria-hidden="true" data-id="element-122" data-mp="zmc405d0t5q0" />;
  return <div className={className} data-id="element-123" data-mp="upbvlnsp7qvq">
      {rule === 'above' ? line : null}
      <p className={`eyebrow font-display text-[0.7rem] font-semibold text-orange sm:text-[0.76rem] ${rule === 'above' ? 'mt-3.5' : ''}`} style={{
      letterSpacing: '0.24em'
    }} data-id="element-124" data-mp="18o1vfb6wk4ns">
        {label}
      </p>
      {rule === 'below' ? <span className="mt-3 block" data-id="element-125" data-mp="2f3lzy6zotyvq">{line}</span> : null}
    </div>;
}